import React, { useState } from 'react';

import { ReactComponent as InfoIcon } from '@/assets/icons/info.svg';
import ExplanatoryModal from '@/components/molecules/ExplanatoryModal';
import WorkActivityExplanatoryImg1 from '@/assets/images/budget-explanatory-1.png';
import WorkActivityExplanatoryImg2 from '@/assets/images/budget-explanatory-2.png';
import WorkActivityExplanatoryImg3 from '@/assets/images/budget-explanatory-3.png';

const steps = [
  {
    title: 'Activity details',
    message:
      'Describe what you worked on, pick the budget it belongs to, and record the date and time window so your entry can be reviewed accurately.',
    img: WorkActivityExplanatoryImg1
  },
  {
    title: 'Allocation',
    message:
      'In the next step you will allocate this work activity across the right accounts or categories so amounts flow correctly in your budget.',
    img: WorkActivityExplanatoryImg2
  },
  {
    title: 'Documents',
    message: 'Add any files or references that support your activity so approvers have full context.',
    img: WorkActivityExplanatoryImg3
  }
];

export interface CreateWorkActivityHeaderProps {
  title: string;
  /** Shown under the title (e.g. current section label). */
  subtitle?: string;
}

const CreateWorkActivityHeader: React.FC<CreateWorkActivityHeaderProps> = ({ title, subtitle }) => {
  const [isExplanatoryOpen, setIsExplanatoryOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <>
      <header className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <div className="flex flex-col gap-1 items-center md:items-start text-center md:text-left flex-1 min-w-0">
          <h1 className="text-base md:text-2xl font-semibold">{title}</h1>
          {/* {subtitle ? <p className="text-sm text-secondary">{subtitle}</p> : null} */}
        </div>
        <button
          type="button"
          title="Info"
          onClick={() => {
            setCurrentStep(0);
            setIsExplanatoryOpen(true);
          }}
          className="hidden md:block shrink-0"
        >
          <InfoIcon />
        </button>
      </header>

      {isExplanatoryOpen && (
        <ExplanatoryModal
          isOpen={isExplanatoryOpen}
          steps={steps}
          currentStep={currentStep}
          buttonText="Next"
          onButtonClick={() => {
            setCurrentStep(currentStep + 1);
          }}
          onClose={() => {
            setIsExplanatoryOpen(false);
          }}
          onStepChange={setCurrentStep}
        />
      )}
    </>
  );
};

export default CreateWorkActivityHeader;
